module.exports = __webpack_public_path__ + "static/media/workplace.0c896daf.jpg";